import React, { useState } from 'react';
import HelpDrawer from './HelpDrawer';

/**
 * HelpButton — drop into the top-right of any module.
 *
 * Usage:
 *   <HelpButton moduleKey="acd_floor" />
 *
 * Click → opens a side drawer with the help article for that module.
 */
export default function HelpButton({ moduleKey, label = 'Help', className = '' }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Open help for this page"
        className={
          'px-2 py-1 text-xs rounded-thin border border-surface-border dark:border-surface-dark-border hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle whitespace-nowrap ' +
          className
        }
      >
        ❓ {label}
      </button>
      {open && <HelpDrawer moduleKey={moduleKey} onClose={() => setOpen(false)} />}
    </>
  );
}
